import type { SavedFilter } from 'api/savedFilters/savedFilters.api'
import { useLocation, useNavigate } from 'react-router'
import { setGrouping } from 'store/filter/filter'
import { FILTER_QUERYSTRING_PARAM, GROUPING_QUERYSTRING_PARAM } from 'store/filter/urlFilter.helper'

export function useApplySavedFilter(): (filter: SavedFilter) => void {
  const location = useLocation()
  const navigate = useNavigate()

  return (filter) => {
    const [filterPart, groupingPart] = filter.filter.split('&')

    const urlParams = new URLSearchParams(location.search)
    urlParams.set(FILTER_QUERYSTRING_PARAM, filterPart)
    if (groupingPart) {
      setGrouping(groupingPart)
      urlParams.set(GROUPING_QUERYSTRING_PARAM, groupingPart)
    }

    navigate(`${location.pathname}?${urlParams.toString()}${location.hash}`, { replace: true })
  }
}
